unit ChargeListScreenType;
{

/* Initial. */

}

interface

uses
  ChargeItemListType, DeviceItemListType, TypeListType;

type
  TChargeListScreenType = class
  private
    fChargeItemList: TChargeItemListType;
    fDeviceTypeList: TTypeListType;
    fDeviceItemList: TDeviceItemListType;
  published
    property ChargeItemList: TChargeItemListType read fChargeItemList;
    property DeviceTypeList: TTypeListType read fDeviceTypeList;
    property DeviceItemList: TDeviceItemListType read fDeviceItemList;
  end;

implementation

end.
